import { createContext } from 'react'

export const RequestProfileTabEmailsViewTypeContext = createContext()
